const eventBus = window.theme.tagalys.searchAutocomplete.eventBus

class SearchDropdown extends HTMLElement {
  // ─────────────────────────────────────────────
  // Lifecycle
  // ─────────────────────────────────────────────

  constructor () {
    super()

    this.props = {
      translations: window.theme.tagalys.searchAutocomplete.translations,
    }

    this.elements = {
      initialView: this.querySelector('[data-search-dropdown-el="initial-view"]'),
      searchedView: this.querySelector('[data-search-dropdown-el="searched-view"]'),
      searchedViewZero: this.querySelector('[data-search-dropdown-el="searched-view-zero-heading"]'),
      searchedViewAside: this.querySelector('[data-search-dropdown-el="searched-view-aside"]'),
      searchedViewList: this.querySelector('[data-search-dropdown-el="searched-view-list"]'),
      backdrop: this.dialog.querySelector('[data-search-dropdown-el="backdrop"]'),
      initialViewPopular: this.querySelector('[data-search-dropdown-el="initial-view-popular"]')
    }

    this.externalElements = {
      wrapper: this.closest('[data-search-dropdown-external-el="wrapper"]'),
    }

    // Store bound handlers for cleanup
    this._boundHandlers = {
      render: this.render.bind(this),
      handleDropdownOpen: this.handleDropdownOpen.bind(this),
      handleDropdownClose: this.handleDropdownClose.bind(this),
      handleDocumentClick: this.handleDocumentClick.bind(this),
      buildInitialPopularView: this.buildInitialPopularView.bind(this),
    }
  }

  connectedCallback () {
    this.attachEventListeners()
  }

  disconnectedCallback () {
    this.detachEventListeners()
  }

  // ─────────────────────────────────────────────
  // Getters
  // ─────────────────────────────────────────────

  get dialog () {
    return this.closest('dialog')
  }

  get templates () {
    return window.theme.tagalys.searchAutocomplete.templates
  }

  get templateProductCard () {
    return document.getElementById('templateProductCard')
  }

  // ─────────────────────────────────────────────
  // Event Setup
  // ─────────────────────────────────────────────

  attachEventListeners () {
    eventBus.subscribe('searchAutoComplete:state:updated', this._boundHandlers.render)
    eventBus.subscribe('searchAutoComplete:ui:dropdown:open', this._boundHandlers.handleDropdownOpen)
    eventBus.subscribe('searchAutoComplete:ui:dropdown:close', this._boundHandlers.handleDropdownClose)
    eventBus.subscribe('searchAutoComplete:state:initial:updated', this._boundHandlers.buildInitialPopularView)

    this.elements.backdrop.addEventListener('click', this._boundHandlers.handleDropdownClose)

    if (window.matchMedia('(min-width: 750px)').matches) {
      document.addEventListener('click', this._boundHandlers.handleDocumentClick)
    }
  }

  detachEventListeners () {
    eventBus.unsubscribe('searchAutoComplete:state:updated', this._boundHandlers.render)
    eventBus.unsubscribe('searchAutoComplete:ui:dropdown:open', this._boundHandlers.handleDropdownOpen)
    eventBus.unsubscribe('searchAutoComplete:ui:dropdown:close', this._boundHandlers.handleDropdownClose)
    eventBus.unsubscribe('searchAutoComplete:state:initial:updated', this._boundHandlers.buildInitialPopularView)
    this.elements.backdrop.removeEventListener('click', this._boundHandlers.handleDropdownClose)
    document.removeEventListener('click', this._boundHandlers.handleDocumentClick)
  }

  // ─────────────────────────────────────────────
  // Event Handlers
  // ─────────────────────────────────────────────

  handleDocumentClick (event) {
    const searchDropdown = this.externalElements.wrapper
    const searchInput = document.querySelector('search-input')

    if (!searchDropdown.contains(event.target) && !searchInput.contains(event.target)) {
      this.handleDropdownClose()
    }
  }

  handleDropdownOpen () {
    this.dialog.show()
  }

  handleDropdownClose () {
    this.dialog.close()
    document.body.style.overflow = 'visible';
  }

  // ─────────────────────────────────────────────
  // Rendering
  // ─────────────────────────────────────────────

  render () {
    const { term, products, keywords } = window.theme.tagalys.searchAutocomplete.stateLayer.state

    if (term === '') {
      this.showInitialView()
      return
    }

    this.clearSearchedView()

    if (products.length > 0) {
      this.showResults(products, keywords, term)
    } else {
      this.showNoResults(term)
    }
  }

  showInitialView () {
    this.elements.initialView.classList.remove('hidden')
    this.elements.searchedView.classList.add('hidden')
  }

  showResults (products, keywords, term) {
    this.elements.initialView.classList.add('hidden')
    this.elements.searchedView.classList.remove('hidden')

    if (keywords.length > 0) {
      this.elements.searchedViewAside.insertAdjacentHTML(
        'beforeend',
        this.templates.buildSuggestedKeywords(keywords, term)
      )
    }

    this.elements.searchedViewList.insertAdjacentHTML(
      'beforeend',
      this.templates.buildResultsList(products, term, this.templateProductCard)
    )
  }

  showNoResults (term) {
    this.elements.initialView.classList.remove('hidden')
    this.elements.searchedView.classList.add('hidden')

    this.elements.searchedViewZero.insertAdjacentHTML(
      'beforeend',
      `${this.props.translations.noResults} '${term}'`
    )
  }

  clearSearchedView () {
    this.elements.searchedViewZero.replaceChildren()
    this.elements.searchedViewAside.replaceChildren()
    this.elements.searchedViewList.replaceChildren()
  }

  buildInitialPopularView () {
    const { popular } = window.theme.tagalys.searchAutocomplete.stateLayer.state

    if (popular.length > 0) {
      this.elements.initialViewPopular.insertAdjacentHTML(
        'beforeend',
        this.templates.buildPopularTerms(popular)
      )
    }
  }
}

customElements.define('search-dropdown', SearchDropdown)
